import styled from '@emotion/styled';
import { Grid, Typography } from '@material-ui/core';
import { createElement, Fragment } from 'react';

import { SearchAssetResult } from '../../../../entity/SearchAsset';

type Props = {
  previewAsset: SearchAssetResult[number] | null;
};

export const AudioPreview = ({ previewAsset }: Props) => {
  return (
    <Fragment>
      {previewAsset && previewAsset.type === 'audio' && (
        <Grid item style={{ textAlign: 'center' }}>
          <Audio src={previewAsset.lightWeightUrl || previewAsset.originalUrl} controls={true} />
          <Typography>{previewAsset.displayName}</Typography>
        </Grid>
      )}
    </Fragment>
  );
};

const Audio = styled('audio')`
  outline: none;
`;
